import { useState } from 'react';

export const useShakeOnClickOutside = (): { readonly isShaking: boolean; readonly shake: () => void } => {
    const [isShaking, setIsShaking] = useState(false);

    const shake = (): void => {
        setIsShaking(true);
        setTimeout(() => {
            setIsShaking(false);
        }, 500);
    };

    return { isShaking, shake };
};
